import {
  PERMISSION_ACTION_COMPLETE,
  PERMISSION_ACTION_PUBLISH,
  PERMISSION_ACTION_VIEW,
  PERMISSION_ACTION_VOID,
  PERMISSION_ENTITY_PAYMENT,
  type PermissionAction
} from '@klear/constants'
import {
  ORDER_EVENT_STATUS_COMPLETED,
  ORDER_EVENT_STATUS_DRAFT,
  ORDER_EVENT_STATUS_PUBLISHED,
  ORDER_EVENT_STATUS_VOIDED
} from '@klear/constants/order-event-status'
import {
  PAYMENT_STATUS_CANCELED,
  PAYMENT_STATUS_DRAFT,
  PAYMENT_STATUS_FAILED,
  PAYMENT_STATUS_PROCESSING,
  PAYMENT_STATUS_RETURNED,
  PAYMENT_STATUS_SCHEDULED,
  PAYMENT_STATUS_SETTLED,
  isKnownPaymentStatus,
  normalizePaymentStatus,
  type PaymentStatus
} from '@klear/payment/constants'
import type { OrderEventStatusLabelsFor } from '@klear/order-event-lifecycle/lifecycle'

export const PAYMENT_STATUS_LABELS = {
  [PAYMENT_STATUS_DRAFT]: 'Draft',
  [PAYMENT_STATUS_SCHEDULED]: 'Scheduled',
  [PAYMENT_STATUS_PROCESSING]: 'Processing',
  [PAYMENT_STATUS_FAILED]: 'Failed',
  [PAYMENT_STATUS_SETTLED]: 'Settled',
  [PAYMENT_STATUS_CANCELED]: 'Canceled',
  [PAYMENT_STATUS_RETURNED]: 'Returned'
} as const satisfies Record<PaymentStatus, string>

export const PAYMENT_LIFECYCLE_STATUS_LABELS = {
  [ORDER_EVENT_STATUS_DRAFT]: 'Draft',
  [ORDER_EVENT_STATUS_PUBLISHED]: 'Published',
  [ORDER_EVENT_STATUS_COMPLETED]: 'Completed',
  [ORDER_EVENT_STATUS_VOIDED]: 'Voided'
} as const satisfies OrderEventStatusLabelsFor<typeof PERMISSION_ENTITY_PAYMENT>

export const PAYMENT_ACTION_LABELS = {
  [PERMISSION_ACTION_VIEW]: 'View',
  [PERMISSION_ACTION_PUBLISH]: 'Publish',
  [PERMISSION_ACTION_COMPLETE]: 'Complete',
  [PERMISSION_ACTION_VOID]: 'Void'
} as const satisfies Partial<Record<PermissionAction, string>>

export function paymentStatusLabel(status: string): string {
  if (!isKnownPaymentStatus(status)) return status
  return PAYMENT_STATUS_LABELS[normalizePaymentStatus(status)]
}
